import styles from './index.module.css'
import clsx from 'clsx'

import React from 'react'
type Props = {
  children?: React.ReactNode
  style?: Record<string, any>
  header?: React.ReactNode
  sticky?: boolean
}

const SubPane = ({
  children,
  style,
  header,
  sticky,
}: Props): React.ReactElement<'div'> => {
  return (
    <div style={style} className={styles.subPane}>
      <div className={styles.row}>{header}</div>
      <div
        className={clsx(styles.row, {
          [styles.sticky]: sticky,
        })}
      >
        {children}
      </div>
    </div>
  )
}

export default SubPane
